import { taskStatusMeta } from "@/lib/mockData";
import { cn } from "@/lib/utils";

export default function StatusPill({ status }) {
  const meta = taskStatusMeta[status] ?? taskStatusMeta.todo;
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-[10px] font-bold uppercase",
        meta.chip,
      )}
      style={{ letterSpacing: "0.14em" }}
    >
      <span
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: meta.dot }}
      />
      {meta.label}
    </span>
  );
}
